import { Component, Input } from '@angular/core';
import { LocalesArray, Salutations } from '@markant-platform/shared/data-access';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DepartmentAffiliations } from '@markant-platform/shared/user/model';
import { Role } from '@markant-platform/authorizer/model';
import { MarkantSelectOption } from '@markant-platform/shared/util-helpers';
import { TranslocoModule, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { UiCardComponent } from '@markant-platform/shared/ui-card';
import { MarkantElementsModule } from '@markant/elements-angular';
import { FormControlErrorPipe, FormControlKeyErrorPipe } from '@markant-platform/shared/util-pipes';
import { UiCountrySelectComponent } from '@markant-platform/shared/ui-components';
import { NoMailChangeReason } from '../models/no-mail-change-reason';
import { QualificationLevel } from 'data-model';

@Component({
  selector: 'markant-platform-organization-member-details-edit',
  templateUrl: './organization-member-details-form.component.html',
  styleUrls: ['./organization-member-details-form.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgTemplateOutlet,
    UiCardComponent,
    MarkantElementsModule,
    NgIf,
    TranslocoModule,
    FormControlKeyErrorPipe,
    FormControlErrorPipe,
    TranslocoPipe,
    UiCountrySelectComponent,
  ],
})
export class OrganizationMemberDetailsFormComponent {
  @Input() organizationId!: string;
  @Input() isPlatformAdmin?: boolean = false;

  @Input() set form(form: FormGroup<{ user: FormGroup; role: FormGroup }>) {
    this.userForm = form.controls.user;
    this.organizationRoleForm = form.controls.role;
  }

  @Input() set organizationRoles(roles: Role[]) {
    this.organizationRoleOptions = roles.map((role: Role) => ({
      value: role.internalName,
      representation:
        role.localizedDisplayName ?? this.translocoService.translate(`common.platformRoles.${role.internalName}`),
    }));
  }

  @Input() noMailChangeReason?: NoMailChangeReason;

  userForm!: FormGroup;
  organizationRoleForm!: FormGroup;
  protected readonly QualificationLevel = QualificationLevel;
  protected readonly salutationOptions: MarkantSelectOption[] = Salutations.map(salutation => ({
    value: salutation.value,
    representation: this.translocoService.translate(salutation.translationKey),
  }));
  protected readonly languageOptions: MarkantSelectOption[] = LocalesArray.map(language => ({
    value: language.shorthand,
    representation: this.translocoService.translate(`languageSelect.${language.shorthand}`),
  }));
  protected readonly departmentAffiliationOptions: MarkantSelectOption[] = Object.values(DepartmentAffiliations).map(
    (affiliation: string) => ({
      value: affiliation,
      representation: this.translocoService.translate(`register.user.departmentOptions.${affiliation}`),
    })
  );
  protected organizationRoleOptions: MarkantSelectOption[] = [];

  constructor(private readonly translocoService: TranslocoService) {}
}
